import _styled from '@emotion/styled/base';
import { keyframes, css } from '@emotion/react';

const roll = keyframes`
  from { transform: translateY(var(--from, 0)); }
  to   { transform: translateY(var(--to, 0)); }
`;
const emOffset = stepCount => {
  const idx = Math.min(Math.max(stepCount - 1, 0), 4);
  return `${idx}em`;
};
const DigitContainer = _styled("div", {
  target: "e1c9ysiz3"
})({
  name: "1070skz",
  styles: "position:relative;display:inline-block;overflow:hidden;height:1em;line-height:1;mask-image:linear-gradient(\n    to top,\n    transparent,\n    black 10%,\n    black 90%,\n    transparent\n  )"
} );
const DigitStack = _styled("div", {
  target: "e1c9ysiz2"
})("display:flex;flex-direction:column;--from:", ({
  direction,
  stepCount
}) => direction === 'up' ? `-${emOffset(stepCount)}` : '0', ";--to:", ({
  direction,
  stepCount
}) => direction === 'down' ? `-${emOffset(stepCount)}` : '0', ";", ({
  direction
}) => direction === 'none' ? `animation: none;` : css("animation:", roll, " 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) ", direction === 'down' ? 'forwards' : '', ";"), " --animation-color:", ({
  isPositive,
  direction,
  theme
}) => direction === 'none' ? 'inherit' : isPositive ? theme.colorScheme.dataVisualization.marketPositive : theme.colorScheme.dataVisualization.marketNegative, ";");
const DigitItem = _styled("div", {
  target: "e1c9ysiz1"
})("height:1em;line-height:1;color:inherit;animation:", ({
  isAnimating
}) => isAnimating ? colorDisappear : 'none', " 0.8s ease-in-out;");
const colorDisappear = keyframes`
  0% {
    color: inherit;
  }
  20%, 80% {
    color: var(--animation-color);
  }
  100% {
    color: inherit;
  }
`;
const PriceContainer = _styled("div", {
  target: "e1c9ysiz0"
})({
  name: "1skhb1t",
  styles: "font-variant-numeric:tabular-nums;font-feature-settings:'tnum' on,'lnum' on"
} );

export { DigitContainer, DigitItem, DigitStack, PriceContainer };
